import { render, staticRenderFns } from "./AbaCargosConcurso.vue?vue&type=template&id=cdb2917a"
import script from "./AbaCargosConcurso.vue?vue&type=script&lang=ts"
export * from "./AbaCargosConcurso.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports